import React from 'react';
import {
  Square,
  Column,
  Copy,
  Flex,
  Badge,
} from '@grubhubprod/gh-cookbook-react/dist';
import { TaxExemptionCertificate } from 'src/types/TaxExemptionCertificate';
import { ColumnWidths } from 'src/components/enterprise/features/TaxExemptions/ExemptionCertificateList/tableSpacing';
import { colorForStatus } from 'src/components/enterprise/features/TaxExemptions/ExemptionCertificateList/statusColor';

import { formatISOString } from 'src/utilities/time-utils';

type ExemptionCertificateProps = {
  certificate: TaxExemptionCertificate;
};

const dateFormatString = 'P';

export default function ExemptionCertificate({
  certificate,
}: ExemptionCertificateProps): JSX.Element {
  return (
    <Square inset="lg" borderBottom="1px solid" borderColor="lightLine">
      <Flex alignItems="center">
        <Column gutter={0} phone={ColumnWidths.name}>
          <Copy variant="body">{certificate.name}</Copy>
        </Column>
        <Column gutter={0} phone={ColumnWidths.state}>
          <Copy variant="body">{certificate.state}</Copy>
        </Column>
        <Column gutter={0} phone={ColumnWidths.status}>
          <Badge
            backgroundColor={colorForStatus(certificate.status)}
            size="sm"
            variant="primary"
            textColor="globals.black"
          >
            {certificate.status}
          </Badge>
        </Column>
        <Column gutter={0} phone={ColumnWidths.expiration}>
          <Copy variant="body">
            {formatISOString(certificate.expirationDate, dateFormatString)}
          </Copy>
        </Column>
      </Flex>
    </Square>
  );
}
